import { singleton } from "tsyringe";
import { AssetsLoader } from "./assets-loader";
import { EventsOrchestrator } from "./orchestrators/events";
import { MainOrchestrator } from "./orchestrators/main";

@singleton()
export class App {
  constructor(
    private loader: AssetsLoader,
    private orchestrator: MainOrchestrator,
    private eventsOrchestrator: EventsOrchestrator
  ) {}
  async run() {
    await this.loader.load();
    this.eventsOrchestrator.init();
    await this.orchestrator.start();
  }
}
